import { stats } from "@/mocks/site";

export default function AboutIntro() {
  return (
    <section aria-label="品牌介绍">
      <div className="relative h-[280px] overflow-hidden md:h-[360px]">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20editorial%20desk%20scene%20with%20stacked%20archival%20folders%20and%20amber%20desk%20lamp%20glow%2C%20deep%20green%20wall%2C%20moody%20documentary%20photography%2C%20soft%20blur%2C%20cinematic%20warm%20tones&width=1600&height=700&seq=hlbg-about-hero&orientation=landscape"
          alt="黑料八卦网编辑部的工作场景示意"
          title="黑料八卦网 - 内容整理与深扒编辑"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/75 to-foreground-950/45"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full max-w-content px-4 md:px-6">
            <p className="text-xs font-medium tracking-[0.3em] text-accent-400">ABOUT US</p>
            <h1 className="mt-3 max-w-2xl font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
              我们把八卦，当成一份需要核实的工作
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200">
              黑料八卦网成立于对「表面热点」的厌倦。我们相信，一件娱乐事件的真正价值不在于谁先发，而在于谁把它讲明白了。
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
              <span className="h-1 w-6 bg-primary-500"></span>
              网站定位
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专注圈内秘闻与深扒的爆料档案站
            </h2>
            <div className="mt-5 space-y-4 text-sm leading-[1.9] text-foreground-700 md:text-base">
              <p>
                黑料八卦网是一家专注娱乐行业秘闻整理与深度起底的内容站点，围绕黑料八卦爆料、内幕与猛料展开持续追踪。
                我们服务的读者，是那群已经不满足于「谁和谁同框了」这类表面信息，想要知道事情究竟怎么发生的人。
              </p>
              <p>
                我们不追逐发布速度，而是把每一次黑料八卦深扒做成一份可以反复查阅的档案：时间线、证据链、各方表述的差异点，
                以及哪些信息仍然存疑。这样做的代价是慢，好处是经得起回看。
              </p>
              <p>
                在内容表达上，我们坚持匿名化处理。在证据链不完整的情况下，任何点名都是不可逆的伤害，
                所以我们更愿意用「某艺人」「某剧组」这样的表述，把判断的空间留给读者。
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-4">
              {stats.map((item) => (
                <div key={item.label} className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                  <p className="font-heading text-xl font-bold text-primary-600 md:text-2xl">{item.value}</p>
                  <p className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 rounded-lg bg-secondary-950 p-5">
              <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </span>
                关于我们
              </p>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                我们是一个线上内容团队，不设线下接待。所有沟通都通过投稿邮箱与订阅表单完成，也欢迎通过下方表单提交线索。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}